import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import * as AU from './anonymous-user.component';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		NgbModule
	],
	declarations: [
		AU.AnonymousUserWelcomeComponent,
		AU.AnonymousUserWelcomeDialog
	],
	exports: [
		AU.AnonymousUserWelcomeComponent,
		AU.AnonymousUserWelcomeDialog
	]
})
export class AnonymousUserComponentModule { }
